export const card = [
    {
        key: "1",
        count: "124",
        text: "Customers Serviced",
        image: "../Images/service.png",
    },
    {
        key: "2",
        count: "3.450",
        text: "Location Serviced",
        image: "../Images/profile.png",
    },
    {
        key: "3",
        count: "86",
        text: "Route Stops Mode",
        image: "../Images/note.png",
    },
    {
        key: "4",
        count: "32",
        text: "Items Installed",
        image: "../Images/items.png",
    },

]   
export const workorder = [
    {
        key: "1",
        image: '../Images/avatar.png',
        name: 'Customer Name',
        category: 'Pool Cleaning',
        task: '45',
        completed: '38',
        progress: '60',
        deadline: 'June 30, 2022'
    },
    {
        key: "2",
        image: '../Images/avatar.png',
        name: 'Customer Name',
        category: 'Pool Cleaning',
        task: '40',
        completed: '38',
        progress: '80',
        deadline: 'July 30, 2022'
    },
    {
        key: "3",
        image: '../Images/avatar.png',
        name: 'Customer Name',
        category: 'Pool Cleaning',
        task: '40',
        completed: '38',
        progress: '80',
        deadline: 'July 30, 2022'
    },
    {
        key: "3",
        image: '../Images/avatar.png',
        name: 'Customer Name',
        category: 'Pool Cleaning',
        task: '40',
        completed: '38',
        progress: '80',
        deadline: 'July 30, 2022'
    },
]

export const routedashboard = [
    {
        key: '1',
        image: '../Images/avatar.png',
        techname: 'Alisher Alwani',
        customer: 'John Doe',
        pool: '23 out of 44',
        workorder: '25 out of 54',
        skip: '2',
    },
    {
        key: '2',
        image: '../Images/avatar.png',
        techname: 'Kawish Shafique',
        customer: 'John Doe',
        pool: '40 out of 44',
        workorder: '25 out of 30',
        skip: '5',
    },
    {
        key: '3',
        image: '../Images/avatar.png',
        techname: 'Masab Abdullah',
        customer: 'John Doe',
        pool: '35 out of 44',
        workorder: '254 out of 254',
        skip: '47',
    },
    {
        key: '4',
        image: '../Images/avatar.png',
        techname: 'Nizamuddin',
        customer: 'John Doe',
        pool: '24 out of 44',
        workorder: '80 out of 150',
        skip: '18',
    },

]

export const customerdata = [
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Alisher Alwani',
        Location: '14576 w Desert Cove RdSurprise, AZ 85379',
        mobilenumber: '+1 434 34345 534',
        emial: 'johndoe@gmail.com',
    },

]

export const customers = [
    {
        key: '1',
        image: '../Images/avatar.png',
        name: 'Jane Cooper',
        desc: 'Aliqua id fugiat nostrud...'
    },
    {
        key: '2',
        image: '../Images/avatar.png',
        name: 'Kathryn Murphy',
        desc: 'Aliqua id fugiat nostrud...'
    },
    {
        key: '3',
        image: '../Images/avatar.png',
        name: 'Devon Lane',
        desc: 'Aliqua id fugiat nostrud...'
    },
    {
        key: '4',
        image: '../Images/avatar.png',
        name: 'Robert Fox',
        desc: 'Aliqua id fugiat nostrud...'
    },
    {
        key: '5',
        image: '../Images/avatar.png',
        name: 'Eleanor Pena',
        desc: 'Aliqua id fugiat nostrud...'
    },
]
export const Previewslides = [
    {
        key: '1',
        image: '../Images/Pool.png',
    },
    {
        key: '2',
        image: '../Images/Pool.png',
    },
    {
        key: '3',
        image: '../Images/Pool.png',
    },
    {
        key: '4',
        image: '../Images/Pool.png',
    },
    {
        key: '5',
        image: '../Images/Pool.png',
    },
    {
        key: '6',
        image: '../Images/Pool.png',
    },

]

export const Routeassignments = [
    {
        key: '1',
        date: '17 May 2023',
        day: 'Monday',
        Maindata: [
            {
                id: "1",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "2",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "3",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

        ],

    },

    {
        key: '2',
        date: '31 May 2023',
        day: 'Friday',
        Maindata: [
            {
                id: "1",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "2",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "3",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

        ],

    },

    {
        key: '3',
        date: '25 june 2023',
        day: 'Thursday',
        Maindata: [
            {
                id: "1",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "2",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "3",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

        ],

    },

    {
        key: '4',
        date: '18 August 2023',
        day: 'Thursday',
        Maindata: [
            {
                id: "1",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "2",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

            {
                id: "3",
                pool: '12',
                allpool: '14',
                workorder: '20',
                allwork: '35',
                skip: '5',
                name: 'Alisher Alwani',
                progress: '55',
                Data: [
                    {
                        id: '01',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '02',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '03',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                    {
                        id: '04',
                        address: '2019, N. 155th Dr.',
                        poolmname: 'Alaska mess',
                        time: '0g 31m',
                        distance: '17miles'
                    },
                ],
            },

        ],

    },



]
export const chemicalData = [
    {
        key: '1',
        Date: "12 May 2023",
        PoolCount: "02",
        TotalPrice: "$12",
        TotalCost: "$120",
        Profit: "$120",
        image: '../Images/avatar.png',
        name: 'Jane Cooper',
        desc: 'Aliqua id fugiat nostrud...'
    }] 